// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-H":"H_amazon-sale-H__GPswt"};